import script from "./Skills.vue?vue&type=script&setup=true&lang=js"
export * from "./Skills.vue?vue&type=script&setup=true&lang=js"

import "./Skills.vue?vue&type=style&index=0&id=1e46aa44&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e46aa44"]])

export default __exports__